import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { getRegistration, getRegisterUser, message, requestRegister, getSubsite } from '../reducers/auth';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import AuthService from "../services/auth.service";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import RegistrationService from "../services/registration.service";

const RequestRegistration = () => {
  let navigate = useNavigate();
  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successful, setSuccessful] = useState(false);
  const theMessage = useSelector(message);
  const [registerUser, setRegisterUser] = useState({});
  let [searchParams, setSearchParams] = useSearchParams();
  const currentSubsite = useSelector(getSubsite);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const recaptcha = useRef()
  const dispatch = useDispatch();
  const location = useLocation();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const phoneRegExp = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/


  const registerValidationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("*First Name is required"),
    lastName: Yup.string()
      .required("*Last Name is required"),
    email: Yup.string()
      .required("*Email is required"),
    company: Yup.string()
      .required("*Company is required"),
    region: Yup.string(),
    phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid')

  });



  return (
    <div className="container">
      {error && !loading && (
        <div className="alert alert-danger" role="alert">
          <p>{error}</p>
          <p>
            If you already Registered, <a href="/login">Login Here</a>
          </p>
        </div>
      )}
      {!error && !loading && (
        <div style={{ marginBottom: 70 }}>

          <p>Welcome to Ignite Gear.  To finish your registration, enter your shipping address below and set your password.  After registration, you will be asked to login with your new password.</p>
          <Formik
            initialValues={{ firstName: "", lastName: "", email: "", company: "", region: "" }}
            validationSchema={registerValidationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              if (!executeRecaptcha) {
                console.log('Execute recaptcha not yet available');
                setError("reCAPTCHA not loaded. Please refresh the page and try again.");
                return;
              }

              try {
                const token = await executeRecaptcha('register');
                console.log("RECAPTCHA TOKEN", token);

                // When button submits form and form is in the process of submitting, submit button is disabled
                console.log("FORM VALUES", values);
                setSubmitting(true);
                setError("");

                // Send token along with form data to backend
                const dataWithToken = {
                  ...values,
                  recaptchaToken: token
                };

                await RegistrationService.addRegistrationRequest(dataWithToken);
                setSubmitting(false);
                navigate("/requestsuccess");
              } catch (error) {
                console.error("Error submitting registration request:", error);
                setError(error.response?.data?.message || "Failed to submit registration request. Please try again.");
                setSubmitting(false);
              }
            }}
          >
            {/* Callback function containing Formik state and helpers that handle common form actions */}
            {({ values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting }) => (
              <Form onSubmit={handleSubmit} >
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    name="email"
                    type="text"
                    placeholder="Email Address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    disabled={searchParams.get("id") ? true : false}
                    className={touched.email && errors.email ? "error" : null}
                  />
                  {touched.email && errors.email ? (
                    <div className="error-message">{errors.email}</div>
                  ) : null}

                </Form.Group>
                <Form.Group className="mb-3" controlId="firstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    name="firstName"
                    type="text"
                    placeholder="First Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.firstName}
                    disabled={searchParams.get("id") ? true : false}
                    className={touched.firstName && errors.firstName ? "error" : null}
                  />
                  {touched.firstName && errors.firstName ? (
                    <div className="error-message">{errors.firstName}</div>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3" controlId="lastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    name="lastName"
                    type="text"
                    placeholder="Last Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lastName}
                    disabled={searchParams.get("id") ? true : false}
                    className={touched.lastName && errors.lastName ? "error" : null}
                  />
                  {touched.lastName && errors.lastName ? (
                    <div className="error-message">{errors.lastName}</div>
                  ) : null}
                </Form.Group>

                <Form.Group className="mb-3" controlId="phoneNumber">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    name="phoneNumber"
                    type="text"
                    placeholder="Phone Number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phoneNumber}
                    className={touched.phoneNumber && errors.phoneNumber ? "error" : null}
                  />
                  {touched.phoneNumber && errors.phoneNumber ? (
                    <div className="error-message">{errors.phoneNumber}</div>
                  ) : null}
                </Form.Group>

                <Form.Group className="mb-3" controlId="company">
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    name="company"
                    type="text"
                    placeholder="Company"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.company}
                    className={touched.company && errors.company ? "error" : null}
                  />
                  {touched.company && errors.company ? (
                    <div className="error-message">{errors.company}</div>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3" controlId="region">
                  <Form.Label>Region</Form.Label>
                  <Form.Control
                    name="region"
                    type="text"
                    placeholder="Region (optional)"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.region}
                    className={touched.region && errors.region ? "error" : null}
                  />
                  {touched.region && errors.region ? (
                    <div className="error-message">{errors.region}</div>
                  ) : null}
                </Form.Group>

                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Request Registration
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      )}

    </div>
  );
};
export default RequestRegistration;